import { TabView, TabViewProps, TabViewRef } from '@myosh/odin-components';
import { forwardRef, Ref } from 'react';

type DashboardTabViewType = TabViewProps & {
  isPublicTab?: boolean;
  isEditing?: boolean;
};

const DashboardTabView = (
  { styles, children, id, isPublicTab = true, isEditing = false, onTabChange, activeIndex = 0 }: DashboardTabViewType,
  ref?: Ref<TabViewRef>
) => {
  const handleTabChange = (index: number) => {
    if (index !== activeIndex) {
      onTabChange?.(index);
    }
  };

  return children ? (
    <TabView
      styles={{
        tabStyles: `mr-4 cursor-pointer text-gray-3 hover:text-primary-1 font-medium tabElement ${
          isEditing ? 'is-editing' : ''
        }`,
        activeTabStyles: `font-medium text-base text-primary-2 border-b-2 border-solid border-primary-2 is-active ${
          isPublicTab ? 'is-public' : 'is-private'
        }`,
        inactiveTabStyles: 'border-none',
        //there is bug in odin components on how styles are set, so adding this class name in case the bug is fixed to be back compatible
        scrollerBorderStyles: 'elementNavigatorStyles',
        ...styles,
      }}
      activeIndex={activeIndex}
      onTabChange={handleTabChange}
      id={id}
      ref={ref}
    >
      {children}
    </TabView>
  ) : null;
};

export default forwardRef(DashboardTabView);
